import { X } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface AudienceCreateSimplifiedHelpCardProps {
  onDismiss: () => void;
  className?: string;
}

export function AudienceCreateSimplifiedHelpCard({
  onDismiss,
  className,
}: AudienceCreateSimplifiedHelpCardProps) {
  const { LL } = useI18nContext();

  return (
    <div
      className={cn(
        'relative mx-auto w-full max-w-lg px-6 py-8 text-center',
        className
      )}
    >
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="absolute right-2 top-2 shrink-0"
        onClick={onDismiss}
        aria-label={LL.audiences.create.simplifiedHelp.dismissAriaLabel()}
      >
        <X className="size-4" />
      </Button>
      <h2 className="text-2xl font-medium tracking-tight sm:text-3xl">
        {LL.audiences.create.simplifiedHelp.title()}
      </h2>
      <p className="mt-3 text-sm text-muted-foreground sm:text-base">
        {LL.audiences.create.simplifiedHelp.description()}
      </p>
    </div>
  );
}
